(function () {
  function initHeaderSearchTransition() {
    const wrappers = document.querySelectorAll(".header-search-input-wrapper");
    if (!wrappers.length) return;

    wrappers.forEach(function (searchWrapper) {
      const searchForm = searchWrapper.closest(".header-search-form");
      const searchInput =
        searchWrapper.querySelector(".header-search-input") ||
        document.querySelector(".boost-sd__search-widget-init-input");
      const submitButton = searchWrapper.querySelector(".header-search-submit");

      if (!searchForm || !searchInput) return;

      function blockSearchNavigation(event) {
        event.preventDefault();
        event.stopPropagation();
      }

      searchForm.addEventListener("submit", blockSearchNavigation, true);

      searchInput.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
        }
      });

      function isDesktopExpandable() {
        return (
          window.matchMedia("(min-width: 960px)").matches &&
          !searchForm.classList.contains("mobile-header-search-form")
        );
      }

      function isBoostOpen() {
        return searchInput.getAttribute("aria-expanded") === "true";
      }

      function syncSearchState() {
        if (!isDesktopExpandable()) {
          searchWrapper.classList.remove("is-expanded");
          return;
        }

        const activeEl = document.activeElement;
        const inputFocused = activeEl === searchInput;
        const clickedInsideHeader = activeEl ? searchWrapper.contains(activeEl) : false;
        const boostOpen = isBoostOpen();

        searchWrapper.classList.toggle(
          "is-expanded",
          inputFocused || clickedInsideHeader || boostOpen
        );
      }

      if (submitButton) {
        submitButton.addEventListener("click", function (event) {
          if (!isDesktopExpandable()) return;
          if (searchWrapper.classList.contains("is-expanded")) return;

          event.preventDefault();
          searchInput.focus();
          syncSearchState();
        });
      }

      searchInput.addEventListener("focus", syncSearchState);
      searchInput.addEventListener("input", syncSearchState);
      searchInput.addEventListener("click", syncSearchState);

      searchInput.addEventListener("blur", function () {
        setTimeout(syncSearchState, 100);
      });

      document.addEventListener("click", function () {
        setTimeout(syncSearchState, 50);
      });

      window.addEventListener("resize", syncSearchState);

      const observer = new MutationObserver(syncSearchState);
      observer.observe(searchInput, {
        attributes: true,
        attributeFilter: ["aria-expanded"],
      });

      syncSearchState();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeaderSearchTransition);
  } else {
    initHeaderSearchTransition();
  }
})();
